import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
  padding: .4rem;
`

export const ModalCustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
  width: 100% !important;

  & input {
    height: 1rem !important;
  }
`
